<template>
  <div>
    <div
      class="choice"
      @click="selectInput()"
      :class="selected ? 'selected' : ''"
    >
      <div class="columns is-gapless is-multiline is-mobile is-vcentered mobile-check">
        <div class="column is-narrow" style="margin: auto;">
          <transition name="slideb" mode="out-in">
            <span class="icon is-medium" v-if="!selected" key="unchecked">
              <i class="far fa-2x fa-circle" style="color: grey;"></i>
            </span>
            <span class="icon is-medium" v-if="selected" key="checked">
              <i class="far fa-2x fa-check-circle" style="color: #1a689b;"></i>
            </span>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Radio",
  model() {
    return { value: "", typed: false };
  },
  props: {
    val: Boolean,
    id: Number
  },
  watch: { 
      val: function(newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.selected = newVal
      }
    },
  data() {
    return {
      field: this.inputField,
      selected: false
    };
  },
  methods: {
    modified() {
      this.setValue(this.selected)
      this.$emit("changed", {selected: this.selected, id: this.$props.id})
      this.validate();
    },
    validate() {
      // console.log("validating");
    },
    setValue(s) {
      // this.modified();
    },
    selectInput() {
      if(this.selected)return;
      this.selected = !this.selected;
      this.modified();
      this.validate(); 
    }
  },
  mounted() {
    this.selected = this.$props.val
  }
};
</script>
<style scoped>
.field {
  padding: 20px 20px;
  background: #edf0f3;
  border-radius: 5px;
  margin: 12px 0px;
}
.choice {
  padding: 15px;
  transition: all 0.75s;
  margin: 20px auto 0px !important;
  width:70px;
  cursor: pointer;
  border: none;
  border-radius: 100px;
}
.selected {
  background: #cedbff;
}

.cardiff-selected{
  background: #cedbff;
}

@media only screen and (max-width: 1024px) {
  .choice{
    border:none;
    margin-top:0 !important;
    border-radius: 100px;
  }
}
</style>
